import { fetchAPI } from '@/services/prismic';
import { camelize } from '@/scripts/camelize';

const getUniversityQuery = `
query allUniversity_page($id: String!) {
  allUniversity_pages(uid: $id) {
    edges {
      node {
        meta_title
        meta_description
        logo
        title
        description
        university_reviews {
          ... on Reviews {
            title
            sub_title
            review_items {
              review_item {
                ... on Review_item {
                  title
                  image
                  author
                  position
                  location
                  review_text
                }
              }
            }
          }
        }
        images {
          unimage
        }
      }
    }
  }
}
`;

const getUniversityIdsQuery = `
query getUniversityIds {
  allUniversity_pages {
    edges {
      node {
        _meta {
          id
        }
      }
    }
  }
}
`;

const getAllUniversitiesQuery = `
query getAllUniversities {
  allUniversity_pages{
    edges {
      node {
        _meta {
          id
          uid
        }
        meta_title
        meta_description
        logo 
        title
        description
        url {
          ... on _ExternalLink {
            url
            target
          }
        }
      }
    }
  }
}
`;

export const fetchUniversityContent = async (id = '', previewData) => {
  const {
    allUniversity_pages: {
      edges: [{
        node: universityContent, 
      } = {}] = [], 
    } = {},
  } = await fetchAPI(getUniversityQuery, {
    previewData,
    variables: {
      id,
    },
  });

  return camelize({
    ...universityContent,
  });
};

export const fetchUniversityIds = async (previewData = false) => {
  const {
    allUniversity_pages: {
      edges: posts = [],
    } = {},
  } = await fetchAPI(getUniversityIdsQuery, {
    previewData,
  });

  return camelize(posts);
}

export const fetchAllUniversities = async (previewData = false) => {
  const {
    allUniversity_pages: {
      edges: universities = [],
    } = {},
  } = await fetchAPI(getAllUniversitiesQuery, {
    previewData,
  });
  
  return camelize(universities);
}
